










import { Vue, Component } from 'vue-property-decorator';
import ListaDistribucion from '@/pantallas/ListaDistribucion/ListaDistribucion.vue';

@Component({
  components: { ListaDistribucion },
})
export default class ListaDistribucionPantalla extends Vue {}
